import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { SplitText } from 'gsap/dist/SplitText'
import { gsap } from 'gsap'

gsap.registerPlugin(SplitText)

const useSplitTexts = (components, opts, deps = []) => {
  const splitTextInstances = useRef({})

  useIsomorphicLayoutEffect(() => {
    for (const { ref, key } of components) {
      const element = ref.current

      // SplitText requires element attached to DOM with content
      if (!element?.parentNode || !element.textContent?.trim()) {
        continue
      }

      try {
        splitTextInstances.current[key] = new SplitText(element, opts)
      } catch (error) {
        console.warn(`[useSplitTexts] Failed for ${key}:`, error.message)
      }
    }
  }, [])

  useIsomorphicLayoutEffect(() => {
    for (const key in splitTextInstances.current) {
      splitTextInstances.current[key]?.split()
    }

    return () => {
      for (const key in splitTextInstances.current) {
        splitTextInstances.current[key]?.revert()
      }
    }
  }, deps)

  return splitTextInstances
}

export default useSplitTexts
